import { SIGN_OUT, SIGN_IN, RESET_AUTH, RESET_PASSWORD, CONFIRM_PASSWORD_RESET } from '@constants';
import { createEntityActions } from 'actionCreators';
import { createAction } from '@reduxjs/toolkit';

// Lazy: @constants imports this module back, so SIGN_OUT is unset at load.
export const clearSession = () => {
  return {
    type: SIGN_OUT,
  };
};

export const resetAuth = () => {
  return {
    type: RESET_AUTH,
  };
};

export const signIn = () => createEntityActions(SIGN_IN);

export const resetPassword = () => createEntityActions(RESET_PASSWORD);
